/*
 *
 * Ctydents reducer
 *
 */
import produce from 'immer';
import {
  FLUSH_STATE,
  LOAD_COURSES,
  LOAD_COURSES_SUCCESS,
  LOAD_COURSES_ERROR,
  UPDATE_COURSE,
  UPDATE_COURSE_SUCCESS,
  UPDATE_COURSE_ERROR,
} from './constants';

export const initialState = {
  firstRender: true,
  loading: false,
  error: false,
  courseDetail: false,
  itemsList: [],
  appointments: [],
  options: false,
};

/* eslint-disable default-case, no-param-reassign */
const coursesMobileReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case FLUSH_STATE:
        return initialState;

      case LOAD_COURSES:
        draft.loading = true;
        draft.error = false;
        draft.firstRender = true;
        draft.itemsList = [];
        draft.appointments = [];
        draft.options = action.options;
        break;

      case LOAD_COURSES_SUCCESS:
        draft.loading = false;
        draft.itemsList = action.itemsList;
        draft.appointments = action.appointments;
        break;

      case LOAD_COURSES_ERROR:
        draft.error = action.error;
        draft.loading = false;
        draft.itemsList = [];
        draft.appointments = [];
        draft.options = false;
        break;

      // Update for Single Element
      case UPDATE_COURSE:
        draft.firstRender = false;
        draft.loading = false;
        draft.error = false;
        draft.courseDetail = action.courseDetail;
        break;

      case UPDATE_COURSE_SUCCESS:
        draft.loading = false;
        const { courseDetail } = action;
        draft.courseDetail = courseDetail;
        let listData = draft.itemsList.data;
        let index = draft.itemsList.data.findIndex(
          po => po._id === courseDetail._id,
        );
        index !== -1
          ? (listData[index] = courseDetail)
          : listData.unshift(courseDetail);
        draft.itemsList = { ...draft.itemsList, data: listData };
        break;

      case UPDATE_COURSE_ERROR:
        draft.error = action.error;
        draft.loading = false;
        break;
    }
  });

export default coursesMobileReducer;
